import { createListingStepMachine } from '../../../step-machine/listingStep.machine';
import { API_CALLS } from './api';
import { BasicInfoFormValues } from './types';

// [MCV-1523] Same as the job-listing basic-info step: this PATCHes the listing,
// so its response belongs on `context.listing` through the parent's
// `updateListing`, not merged into `listing.detail`.
export const basicInfoMachine = createListingStepMachine<BasicInfoFormValues>(
  API_CALLS.patch,
  'msaasListingsState',
  API_CALLS.create,
  'ON_ADD_LISTING',
  'ON_UPDATE_LISTING'
);
